import {
  getPendingCatalogImports,
  setPendingCatalogImports,
} from "@/utils/auth-storage";
import { useCallback, useMemo, useState } from "react";
import {
  CATALOG_IMPORT_LABEL_SEPARATOR,
  CATALOG_IMPORT_NOTICE_SUFFIX,
  CATALOG_TABS,
} from "../catalog-constant";
import { CatalogImportType, CatalogTab } from "../catalog-types";

type UsePendingCatalogImportsReturn = {
  pendingTabs: CatalogTab[];
  notice: string;
  isImportPending: (type: CatalogImportType) => boolean;
  markImported: (type: CatalogImportType) => void;
};

export const usePendingCatalogImports = (): UsePendingCatalogImportsReturn => {
  const [pendingTypes, setPendingTypes] = useState<string[]>(
    getPendingCatalogImports
  );

  const isImportPending = useCallback(
    (type: CatalogImportType) => pendingTypes.includes(type),
    [pendingTypes]
  );

  const markImported = useCallback((type: CatalogImportType) => {
    setPendingTypes((current) => {
      const remaining = current.filter((pending) => pending !== type);
      setPendingCatalogImports(remaining);
      return remaining;
    });
  }, []);

  const pendingTabs = useMemo(
    () => CATALOG_TABS.filter((tab) => pendingTypes.includes(tab.importType)),
    [pendingTypes]
  );

  const notice = useMemo(
    () =>
      `${pendingTabs.map((tab) => tab.label).join(CATALOG_IMPORT_LABEL_SEPARATOR)} ${CATALOG_IMPORT_NOTICE_SUFFIX}`,
    [pendingTabs]
  );

  return { pendingTabs, notice, isImportPending, markImported };
};
